export default {
    warnings: {
        straightRow: 'Deretan tombol pada keyboard mudah untuk ditebak.',
        keyPattern: 'Pola keyboard yang pendek lebih mudah untuk ditebak.',
        simpleRepeat: 'Karakter berulang seperti "aaa" mudah ditebak.',
        extendedRepeat: 'Pola karakter berulang seperti "abcabcabc" mudah ditebak.',
        sequences: 'Urutan karakter umum seperti "abc" mudah ditebak.',
        recentYears: 'Tahun-tahun terakhir mudah ditebak.',
        dates: 'Tanggal mudah ditebak.',
        topTen: 'Ini adalah kata sandi yang banyak digunakan.',
        topHundred: 'Ini adalah kata sandi yang sering digunakan.',
        common: 'Ini adalah kata sandi yang umum digunakan.',
        similarToCommon: 'Ini mirip dengan kata sandi yang umum digunakan.',
        wordByItself: 'Satu kata mudah ditebak.',
        namesByThemselves: 'Nama tunggal atau nama keluarga mudah ditebak.',
        commonNames: 'Nama umum dan nama keluarga mudah ditebak.',
        userInputs: 'Mengandung data personal.',
        pwned: 'Password pernah terekspos pada kebocoran data di Internet.',
    },
    suggestions: {
        l33t: "Hindari penggantian huruf yang dapat diprediksi seperti '@' untuk 'a'.",
        reverseWords: 'Hindari ejaan terbalik dari kata-kata umum.',
        allUppercase: 'Kapitalisasi beberapa, tetapi tidak semua huruf.',
        capitalization: 'Kapitalisasi lebih dari huruf pertama.',
        dates: 'Hindari tanggal dan tahun yang berhubungan dengan Anda.',
        recentYears: 'Hindari beberapa tahun terakhir.',
        associatedYears: 'Hindari tahun-tahun yang berhubungan dengan Anda.',
        sequences: 'Avoid common character sequences.',
        repeated: 'Hindari urutan karakter yang umum.',
        longerKeyboardPattern: 'Gunakan pola keyboard yang lebih panjang dan ubah arah pengetikan beberapa kali.',
        anotherWord: 'Tambahkan lebih banyak kata yang kurang umum.',
        useWords: 'Gunakan banyak kata, tetapi hindari frasa umum.',
        noNeed: 'Anda dapat membuat kata sandi yang kuat tanpa menggunakan simbol, angka, atau huruf besar.',
        pwned: 'Jika Anda menggunakan kata sandi ini di tempat lain, Anda harus mengubahnya.',
    },
    timeEstimation: {
        ltSecond: 'kurang dari satu detik',
        second: '{base} detik',
        seconds: '{base} detik',
        minute: '{base} menit',
        minutes: '{base} menit',
        hour: '{base} jam',
        hours: '{base} jam',
        day: '{base} hari',
        days: '{base} hari',
        month: '{base} bulan',
        months: '{base} bulan',
        year: '{base} tahun',
        years: '{base} tahun',
        centuries: 'abad',
    },
};
//# sourceMappingURL=translations.js.map